import { Outlet, createFileRoute, useLocation } from "@tanstack/react-router";
import { PhonicsPage } from "../../components/media/phonics/PhonicsPage";

export const Route = createFileRoute("/media/phonics")({
  component: PhonicsPageRoute,
});

function PhonicsPageRoute() {
  const location = useLocation();

  // If on a child route (like /trash), render the outlet
  const isChildRoute = location.pathname !== "/media/phonics";

  if (isChildRoute) {
    return <Outlet />;
  }

  return <PhonicsPage />;
}
